<div class="container mx-auto px-4 py-6">
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-800">Textos Legais</h1>
    <p class="text-gray-600 mt-2">Termos de Uso e Política de Privacidade</p>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Key</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Título</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Versão</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let i of items" class="hover:bg-gray-50">
            <td class="px-6 py-4">{{ i.key }}</td>
            <td class="px-6 py-4">{{ i.title }}</td>
            <td class="px-6 py-4">{{ i.version || '—' }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
              <button (click)="edit(i)" class="text-blue-600 hover:text-blue-900">Editar</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
